import {
    FETCH_COUPON_META,
    FETCHING_COUPON_META,
    EDIT_COUPON_META
} from "../actionTypes";

export const fetchingCouponMeta = payload => ({
    type: FETCHING_COUPON_META,
    payload
});

export const fetchCouponMeta = payload => ({
    type: FETCH_COUPON_META,
    payload
});

export const editCouponMeta = payload => ({
    type: EDIT_COUPON_META,
    payload
});